import { render, staticRenderFns } from "./AboutItem.vue?vue&type=template&id=87e92bd8&scoped=true&"
import script from "./AboutItem.vue?vue&type=script&lang=ts&"
export * from "./AboutItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e92bd8",
  null
  
)

export default component.exports